import { render, staticRenderFns } from "./VaimoTransparencyModal.vue?vue&type=template&id=28b6ff6f&scoped=true&"
import script from "./VaimoTransparencyModal.vue?vue&type=script&lang=js&"
export * from "./VaimoTransparencyModal.vue?vue&type=script&lang=js&"
import style0 from "./VaimoTransparencyModal.vue?vue&type=style&index=0&id=28b6ff6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6ff6f",
  null
  
)

export default component.exports